import React, { useEffect, useState } from 'react';
import './styles/main.css';
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Home from './pages/Home/Home';
import TopSelling from './pages/Home/TopSelling';
import Header from './pages/Header/Header';
import Footer from './pages/Common/Footer';
import { useDispatch, useSelector } from 'react-redux';
import { updateWebSettings } from './store/webSettings';
import fetch from './utils/fetch';
import icons from './utils/icons.json';
import TodaysDeals from './pages/Home/TodaysDeals';
import Search from './pages/Header/Search';
import Category from './pages/Home/Category';
import { addCategories } from './store/categories';
import ShoppingCart from './pages/Products/ShoppingCart';
import { addCartItems } from './store/cartItems';
import { getFromStore, setToStore } from './utils/fn';
import Favorites from './pages/Products/Favorites';
import useDocumentTitle from './hooks/useDocumentTitle';
import constants from './utils/constants.json';
import { setRecentlyViewed } from './store/recentlyViewed';
import { setAlert } from './store/alert';
import Checkout from './pages/Products/Checkout';
import { setFavorites } from './store/favorites';
import About from './pages/Common/About';
import { setLoggedIn, setUser } from './store/user';
import Reset from './pages/Common/Reset';
import Signup from './pages/Common/Signup';
import Signin from './pages/Common/Signin';
import ProductPage from './pages/Products/ProductPage';
import ProductsAndServices from './pages/Products/ProductsAndServices';
import Account from './pages/Account/Account';
import ImageViewer from './components/ImageViewer';
import Alert from './components/Alert';
import Buyeraccount from './pages/Account/useraccount';
import Adminnav from './pages/Admin/adminnav';
import { primarycolor } from './utils/colors';
import Classifications from './pages/Home/Classifications';
import HelpPage from './pages/Common/help';

document.oncontextmenu = function (e) {
	//e.preventDefault();
};

window.addEventListener('beforeunload', (e) => {
	return;
	e.preventDefault();
	e.returnValue = '';
});

console.log({
	developer: 'Aim Mikel',
	date: 'Oct - Nov 2021',
	company: 'Primesoft Solutions (K) LTD',
});

function App() {
	const dispatch = useDispatch();
	const webSettings = useSelector((state) => state.webSettings.data);
	const [error, setError] = useState('');



	//removeFromStore('cart-items');

	useDocumentTitle('Home');

	useEffect(() => {
		if (webSettings) {
			document.querySelector('meta[name="theme-color"]').setAttribute('content', webSettings.NAVBAR_COLOR);
			document.querySelector('meta[name="description"]').setAttribute('content', webSettings.FULL_NAME + ' website');
			document.documentElement.style.setProperty(`--themeColor`, webSettings.NAVBAR_TXT_COLOR);
			document.documentElement.style.setProperty(`--bgColor`, webSettings.CART_CARD_BG_COLOR);
			document.documentElement.style.setProperty(`--cardColor`, webSettings.CART_BACKGROUNG_COLOR);
			document.documentElement.style.setProperty(`--textColor`, 'black');

			// document.documentElement.style.setProperty(`--headerBgColor`, webSettings.NAVBAR_TXT_COLOR);
			// document.documentElement.style.setProperty(`--headerTxtColor`, webSettings.NAVBAR_COLOR);
			document.documentElement.style.setProperty(`--headerBgColor`, webSettings.NAVBAR_COLOR);
			document.documentElement.style.setProperty(`--headerTxtColor`, webSettings.NAVBAR_TXT_COLOR);

			document.documentElement.style.setProperty(`--navbarBgColor`, webSettings.NAVBAR_BELOW_TXT_NAVBAR);
			document.documentElement.style.setProperty(`--navbarTxtColor`, webSettings.NAVBAR_BELOW_NAVBAR);

			document.documentElement.style.setProperty(`--footerBgColor`, webSettings.FOOTER_BG_COLOR);
			document.documentElement.style.setProperty(`--footerTxtColor`, webSettings.FOOTER_TEXT_COLOR);
			document.documentElement.style.setProperty(`--footerHeadingTxtColor`, webSettings.FOOTER_HEADING_TEXT_COLOR);
		}
	}, [webSettings]);

	useEffect(() => {
		let favorites = getFromStore(constants.FAVORITES);
		let cartItems = getFromStore(constants.CART_ITEMS);
		let settings = getFromStore(constants.WEB_SETTINGS);
		let categories = getFromStore(constants.CATEGORIES);
		let recentlyViewed = getFromStore(constants.RECENTLY_VIEWED);
		let user = getFromStore(constants.USER_PROFILE);

		if (user) {
			dispatch(setUser(user));
			dispatch(setLoggedIn(true));
		}
		if (favorites) {
			dispatch(setFavorites(favorites));
		}
		if (cartItems) {
			dispatch(addCartItems(cartItems));
		}
		if (recentlyViewed) {
			dispatch(setRecentlyViewed(recentlyViewed));
		}
		if (!settings || !categories) {
			fetchData();
		} else {
			dispatch(updateWebSettings(settings));
			dispatch(addCategories(categories));
			fetchData(true);
		}
	}, []);

	function fetchData(updating = false) {
		if (updating) dispatch(setAlert({ type: 'warning', message: 'Updating site data...', duration: 10000 }));

		Promise.all([fetch.get('getWebsiteSettings'), fetch.get('getProductGroupsWithSubGroups'), fetch.get('locations'), fetch.get('getCompanyName')])
			.then((res) => {
				dispatch(updateWebSettings({ ...res[0].list, ...res[3].list[0], locations: res[2].list }));
				dispatch(addCategories(res[1].list));
				setToStore(constants.WEB_SETTINGS, { ...res[0].list, locations: res[2].list });
				setToStore(constants.CATEGORIES, res[1].list);
				if (updating) dispatch(setAlert('Site updated successful!'));
			})
			.catch((err) => {
				if (!updating) {
					setError(err.message);
					dispatch(setAlert({ type: 'error', message: err.message }));
				} else {
					dispatch(setAlert({ type: 'error', message: 'Error updating site' }));
				}
			});
	}


	return !error && !webSettings ? (
		<div className="waiting" dangerouslySetInnerHTML={{ __html: icons.spinner }}></div>
	) : error && !webSettings ? (
		<div className="error-box">
			<section className="error-header">
				<h3>Error!!</h3>
			</section>
			<section className="error-body">
				<p className="error-msg">{error}</p>
			</section>
		</div>
	) : (
		<div className="wrapper">
			<Router>
				<Header />
				<Routes>
					<Route path="/account" element={<Buyeraccount />} />
					<Route path="/signup" element={<Signup />} />
					<Route path="/signin" element={<Signin />} />
					<Route path="/reset" element={<Reset />} />
					<Route path="/categories/:item_group/:sub_group/:categoryCode" element={<Category />} />
					<Route path="/categories/:item_group/:sub_group" element={<Category />} />
					<Route path="/categories/:item_group" element={<Category />} />
					<Route path="/classifications/:categoryname" element={<Classifications />} />
					<Route path="/search/:category/:query" element={<Search />} />
					<Route path="/product/:code" element={<ProductPage />} />
					<Route path="/todays-deals" element={<TodaysDeals />} />
					<Route path="/top-selling" element={<TopSelling />} />
					<Route path="/products-and-services/:page" element={<ProductsAndServices />} />
					<Route path="/products-and-services" element={<ProductsAndServices />} />
					<Route path="/favorites" element={<Favorites />} />
					<Route path="/checkout" element={<Checkout />} />
					<Route path="/cart" element={<ShoppingCart />} />
					<Route path="/home" element={<Home />} />
					<Route path="/about" element={<About />} />
					<Route path="/help" element={<HelpPage />} />
					<Route path='/' element={<Home />} />
					<Route path="/supportdashboard/*" element={<Adminnav />} exact />
				</Routes>
				<Footer />
				<ImageViewer />
				<div className="fixed-footer">
					<Alert />
				</div>
			</Router>
		</div>
	);
}

export default React.memo(App);
